import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { WeekBudgetValue } from '../../typings/budget';
import { MoneyText } from '../MoneyText/MoneyText';

import './GridCampaignWeekBudgetCell.css';
import * as keyset from './GridCampaignWeekBudgetCell.i18n';

const i18n = i18nFactory(keyset);

export interface GridCampaignWeekBudgetCellProps {
    value: WeekBudgetValue;
    isCompactViewEnabled: boolean;
}

const BLOCK = 'grid-campaign-week-budget-cell';

export class GridCampaignWeekBudgetCell extends React.PureComponent<GridCampaignWeekBudgetCellProps> {
    render() {
        const { value, isCompactViewEnabled } = this.props;

        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: { compact: isCompactViewEnabled }
                })}
            >
                <p className={Bem.cls('grid-campaign-week-budget-cell', 'value')}>
                    <MoneyText num={value.sum} fractionalPartLength={2} />
                </p>

                <p className={Bem.cls('grid-campaign-week-budget-cell', 'hint')}>{i18n('perWeek')}</p>
            </div>
        );
    }
}
